import { StyleSheet, View, type ViewProps } from "react-native";

import {
  radii,
  shadows,
  spacing,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";
import type { Space } from "./types";

export function Card({
  danger = false,
  accent = "none",
  compact = false,
  gap,
  style,
  ...props
}: ViewProps & {
  danger?: boolean;
  /** Soft left accent for metrics / emphasis without double nesting. */
  accent?: "none" | "mint" | "danger";
  compact?: boolean;
  gap?: Space;
}) {
  const { stylesheet, gapStyles } = useThemedStyles(makeStyles);
  const resolvedAccent = danger ? "danger" : accent;

  return (
    <View
      style={[
        stylesheet.card,
        resolvedAccent === "mint" ? stylesheet.mint : null,
        resolvedAccent === "danger" ? stylesheet.danger : null,
        stylesheet.shadow,
        compact ? stylesheet.compact : null,
        gap ? gapStyles[gap] : null,
        style,
      ]}
      {...props}
    />
  );
}

const makeStyles = (colors: ThemeColors) => {
  const stylesheet = StyleSheet.create({
    card: {
      padding: spacing.l,
      borderWidth: 1,
      borderColor: colors.hairline,
      borderRadius: radii.card,
      backgroundColor: colors.background,
    },
    mint: {
      borderLeftWidth: 4,
      borderLeftColor: colors.primary,
    },
    danger: {
      borderColor: colors.danger,
      borderLeftWidth: 4,
      borderLeftColor: colors.danger,
      backgroundColor: colors.dangerSurface,
    },
    shadow: shadows.sm,
    compact: { padding: spacing.m },
    gapNone: { gap: 0 },
    gapXs: { gap: spacing.xs },
    gapSm: { gap: spacing.s },
    gapMd: { gap: spacing.m },
    gapLg: { gap: spacing.l },
    gapXl: { gap: spacing.xl },
    gapXxl: { gap: spacing.xxl },
  });
  const gapStyles = {
    none: stylesheet.gapNone,
    xs: stylesheet.gapXs,
    sm: stylesheet.gapSm,
    md: stylesheet.gapMd,
    lg: stylesheet.gapLg,
    xl: stylesheet.gapXl,
    xxl: stylesheet.gapXxl,
  };
  return { stylesheet, gapStyles };
};
